import React, { Component } from "react";
import { Router } from 'react-router-dom'
import PiwikReactRouter from 'piwik-react-router'

import history from './history'

import Navigation from "./Navigation";
import Main from "./Main";

const piwik = PiwikReactRouter({
  url: "https://stats.ubivox.com",
  siteId: 5,
});

class App extends Component {
  render() {
    return (
      <Router history={piwik.connectToHistory(history)}>
        <div>
          <Navigation />
          <Main />
          <Footer />
        </div>
      </Router>
    );
  }
}

const Footer = (props) => (
  <footer className="footer">
    <div className="container">
      <p className="text-muted text-right">
        Developed at <a href="https://www.ubivox.com" target="_blank" rel="noopener noreferrer">Ubivox Technologies</a>.
        Questions, bugs or suggestions? <a href="mailto:support@ubivox.com">Reach out!</a>
      </p>
    </div>
  </footer>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js